import GroupRenderer from "./group_renderer"
import messageResource from "../messageResource"
import {atImgPath} from "../atBrowserUtils"
import {DateFormat} from "../date_format"
import {DEFAULT_TIME_ZONE_GROUP_ID} from "../constants"

export default class TimeZoneGroupRenderer extends GroupRenderer {
    /**
     * @param config.groupDivClassName class name of user group row
     * @param config.groupTableClassName class name of first table in user group div
     * @param config.folderImgClassName class name of cell with folder image
     * @param config.deleteGroupLinkClassName class name of user group delete button
     * @param config.groupNameCellClassName class name of cell with user group name
     * @param config.counterSpanClassName class name of span with counter of users in user group
     * @param config.waitingAnimationCellClassName class name of cell with waiting ajax animation
     * @param config.editTableCellClassName class name of cell for edited group table
     * @param config.editInputClassName class name of edit user group input field
     * @param config.undoButtonClassName class name of user group undo edit button
     * @param config.acceptButtonClassName class name of user group accept edit button
     * @param config.nullGroupClassName class name of row of bogus 'without user group' user group
     * @param config.confirmDeleteCellClassName class name of cell for confirm delete group
     * @param config.confirmDeleteAcceptButtonClassName class name of accept confirm delete button
     * @param config.confirmDeleteUndoButtonClassName class name of undo confirm delete button
     * @param config.groupDivIdPrefix dom id prefix for user group row
     * @param config.deleteLinkIdPrefix dom id prefix for user group delete button
     * @param config.undoEditIdPrefix dom id prefix for user group undo edit button
     * @param config.acceptEditIdPrefix dom id prefix for user group accept edit button
     * @param config.editInputIdPrefix dom id prefix for user group edit input field
     * @param config.nameCellIdPrefix dom id prefix for cell with user group name
     * @param config.inputCellIdPrefix dom id prefix for cell with edit user group input field
     * @param config.editGroupCellIdPrefix dom id prefix for cell for edited group table
     * @param config.waitingAnimationCellIdPrefix  dom id prefix for cell with waiting ajax animation
     * @param config.confirmDeleteCellIdPrefix dom id prefix for group delete cell
     * @param config.confirmDeleteAcceptButtonIdPrefix dom id prefix for group accept delete button
     * @param config.confirmDeleteUndoButtonIdPrefix dom id prefix for group undo delete button
     * @param config.selectorCellClassName class name for city selector cell
     * @param config.secondRowClassName class name for second row
     * @param config.defaultGroupLabelCellClassName class name for default group label cell
     * @param config.currentTimeCellClassName class name for current time cell
     * @param config.selectorIdPrefix dom id prefix for city selector cell
     */
    init(config) {
        super.init(config);
        this.selectorCellClassName = config.selectorCellClassName;
        this.secondRowClassName = config.secondRowClassName;
        this.defaultGroupLabelCellClassName = config.defaultGroupLabelCellClassName;
        this.currentTimeCellClassName = config.currentTimeCellClassName;
        this.selectorIdPrefix = config.selectorIdPrefix;

        return this;
    }

    buildFolderImgCell(group) {
        const folderImgTd = document.createElement("td");
        folderImgTd.className = this.folderImgClassName;
        const folderImg = document.createElement("img");
        folderImg.src = atImgPath("user_group_lightbox/time-zone.png");
        folderImgTd.appendChild(folderImg);

        return folderImgTd;
    }

    buildCitySelectorCell(group) {
        const selectorTd = document.createElement('td');
        selectorTd.className = this.selectorCellClassName;
        const selectorDiv = document.createElement('div');
        selectorDiv.id = formatId(this.selectorIdPrefix, group.id);
        selectorTd.appendChild(selectorDiv);
        return selectorTd;
    }

    buildEmptyCell() {
        return document.createElement('td');
    }

    buildDefaultGroupLabelCell(group) {
        const labelTd = document.createElement('td');
        labelTd.className = this.defaultGroupLabelCellClassName;
        if (this.validatorGroupStrategy.isDefaultGroup(group)) {
            const labelSpan = document.createElement('span');
            labelSpan.innerHTML = messageResource.getMessage('group_management.default_group');
            labelTd.appendChild(labelSpan);
        }
        return labelTd;
    }

    buildCurrentTimeCell(group) {
        const currentTimeTd = document.createElement('td');
        currentTimeTd.colSpan = 2; // need more space for current time
        currentTimeTd.className = this.currentTimeCellClassName;
        const currentTimeSpan = document.createElement('span');
        currentTimeSpan.innerHTML = messageResource.getMessage('group_management.current_time') + ' ' +
                                    new DateFormat(SystemSettings.dateFormat, SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(group.currentTime));
        currentTimeTd.appendChild(currentTimeSpan);
        return currentTimeTd;
    }

    /**
     * Build columns for group row
     */
    fillTable(table, group) {
        let tr = document.createElement('tr');
        tr.appendChild(this.buildFolderImgCell(group));
        tr.appendChild(this.buildNameCell(group));
        tr.appendChild(this.buildCitySelectorCell(group));
        tr.appendChild(this.buildCountCell(group));
        tr.appendChild(this.buildDeleteCell(group));
        tr.appendChild(this.buildConfirmDeleteCell(group));
        tr.appendChild(this.buildWaitingAnimationCell(group));
        table.appendChild(tr);

        tr = document.createElement('tr');
        tr.className = this.secondRowClassName;
        tr.appendChild(this.buildEmptyCell()); // img cell
        tr.appendChild(this.buildDefaultGroupLabelCell(group)); // name cell
        tr.appendChild(this.buildCurrentTimeCell(group)); // citySelector cell (colspan = 2)
        // skip count cell
        tr.appendChild(this.buildEmptyCell()); // delete cell
        tr.appendChild(this.buildEmptyCell()); // confirmDelete cell
        tr.appendChild(this.buildEmptyCell()); // waiting animation cell
        table.appendChild(tr);
    }

    generateDeleteConfirmMessage() {
        return messageResource.getEscapedMessage("group_management.confirm_delete.message.part_1", [messageResource.getMessage(this.groupNamingKey)]) +
               "<br>" + messageResource.getMessage("group_management.confirm_delete.message.part_2.time_zone_groups");
    }

    getItemText(group) {
        let itemText = super.getItemText(group);

        if (group.id === DEFAULT_TIME_ZONE_GROUP_ID)
            itemText += ' ' + messageResource.getMessage("users_selector.default_group");

        return itemText;
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/time_zone_group_renderer.js